/**
 * The Inbound Labs lockup: the mark followed by "inbound labs" in lowercase
 * Figtree 600. The mark keeps its own gradient — never recolour or box it.
 * Sizes follow the design system: 26px mark with 16px text in the sidebar.
 */
export default function Logo({ size = 26, textClass = "text-base", showText = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 font-display text-foreground ${className}`}>
      <img src="/logo-mark.png" alt={showText ? "" : "Inbound Labs"} width={size} height={size}
        className="shrink-0" style={{ width: size, height: size }} />
      {showText && <span className={`${textClass} font-semibold leading-none tracking-tight`}>inbound labs</span>}
    </span>
  );
}
